import React, { useState, useContext, useRef } from 'react';
import { useHistory } from 'react-router';
import { BsFillCursorFill, BsCardChecklist, BsCloudUpload } from "react-icons/bs";
import { IoChevronBackCircle } from "react-icons/io5";
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import uploadedFilesSservice from '../../services/uploadedFiles.service';
//import AuthContext from 'store/AuthContext';
import APP_CONST from 'constants/application-constants';
import AppButton from 'components/FormsUI/AppButton/appButton';
import ToastContext from 'store/ToastContext';

import './UploadFile.css';

const UploadFile = (props) => {
  //const { userInfo } = useContext(AuthContext);
  const { openToast } = useContext(ToastContext);
  const [selectedFile, setSelectedFile] = useState(null);
  const [errMessage, setErrMessage] = useState("");
  const [activityType, setActivityType] = useState(null);
  const [closeFlight, setCloseFlight] = useState(false);
  const [showCloseFlightCheckBox, setShowCloseFlightCheckBox] = useState(false);
  const [spinnerLoading, setSpinnerLoading] = useState(false);
  const [uploadedFileName, setUploadedFileName] = useState("");
  const history = useHistory();
  const uploadInputRef = useRef(null);

  const onChangeHandler = event => {
    setErrMessage("");
    setSelectedFile(event.target.files[0]);
    setActivityType(1);
    if ((event.target.files[0] !== null) && 
        (event.target.files[0].type === APP_CONST.FILE_TYPE_CSV_v1 ||
          event.target.files[0].type === APP_CONST.FILE_TYPE_CSV_v2)) {
      setShowCloseFlightCheckBox(true);
    }
    else {
      setShowCloseFlightCheckBox(false);
    }

    if (event.target.files[0].type === APP_CONST.FILE_TYPE_CSV_v1 || 
      event.target.files[0].type === APP_CONST.FILE_TYPE_CSV_v2 ||
      event.target.files[0].type === APP_CONST.FILE_TYPE_TEXT_PLAIN) {
      setUploadedFileName(event.target.files[0].name);
    }

  }

  const uploadFileHandler = async () => {
    if (selectedFile == null) {
      openToast("Please select a file", "info");
      return;
    }
    setSpinnerLoading(true);
    if (selectedFile.type === APP_CONST.FILE_TYPE_TEXT_PLAIN || selectedFile.type === APP_CONST.FILE_TYPE_CSV_v1
      || selectedFile.type === APP_CONST.FILE_TYPE_CSV_v2) {
      if (selectedFile != null && (selectedFile.type === APP_CONST.FILE_TYPE_CSV_v1 || selectedFile.type === APP_CONST.FILE_TYPE_CSV_v2)) {
        if (closeFlight) {
          setActivityType(2);
        }
      }
      const FileContent = await selectedFile.text();
      if (FileContent === "") {
        setSelectedFile(null);
        setUploadedFileName("");
        openToast("Upload file failed, error in file format", "error");
        setSpinnerLoading(false);
      } else {
        const data = {
          'FileContent': FileContent,
          'FileOrigin': "P",
          'ActivityType': closeFlight ? 2 : 1,
          'FileName': selectedFile.name
        }

        if (((selectedFile.type === APP_CONST.FILE_TYPE_CSV_v1 ||
          selectedFile.type === APP_CONST.FILE_TYPE_CSV_v2) && activityType !== undefined)
          || selectedFile.type === APP_CONST.FILE_TYPE_CSV_v1 
          || selectedFile.type === APP_CONST.FILE_TYPE_CSV_v2
          || selectedFile.type === APP_CONST.FILE_TYPE_TEXT_PLAIN) {

          const uploadResponse = await uploadedFilesSservice.uploadFile(data);
          let errMass = "";
          if (uploadResponse.length > 0) {
            uploadResponse.forEach(element => {
              if (element.code === 0) {
                openToast("File uploaded", "success");
                history.push("/FlightList",
                  { flightId: element.description }
                  );
              } else if (element.code === 80) {
                resetForm();
                openToast(element.description, "warning");
              } else {
                errMass += element.description + "<br/>";
              }
            });
            if (errMass !== "") {
              resetForm();
              setErrMessage(errMass);
            }
          } else {
            resetForm();
            openToast("General error", "error");
          }
          
        }
        setSpinnerLoading(false);
      }
    } else {
      resetForm();
      openToast("Invalid file format. Please choose another file.", "error");
      setSpinnerLoading(false);
    }
  }

  const resetForm = () =>{
    setSelectedFile(null);
    setUploadedFileName("");
    setCloseFlight(false);
    setShowCloseFlightCheckBox(false);
    if (uploadInputRef!==null && uploadInputRef.current!==null)
    {
    uploadInputRef.current.value = "";
  }
  }

  const redirectToUploadedFiles = () => {
    history.push("/UploadedFilesList");
  }

  const backhandler = () => {
    history.goBack();
  }

  const handleChange = (event) => {
    setCloseFlight(event.target.checked);
  }

  return (
    <div className="container">
      <div className="h-100">
        <h2>Upload flight manifest (TXT or CSV) </h2>
        <div className="d-flex justify-content-end mb-2">
          {props.showFileList &&
            <AppButton action={redirectToUploadedFiles} label="Files List" icon={<BsCardChecklist />}></AppButton>
          }
        </div>
        <div id="uploadFileAria" onClick={()=>uploadInputRef.current.click()}>
          <BsCloudUpload size={props.uploadIconSize}/>
          <AppButton size="lg" classes="uploadBtn" label="Choose file to Upload"></AppButton>
          <div style={{ textAlign: 'center', minHeight: 25 }}>{uploadedFileName && `File: ${uploadedFileName}`}</div>
          <input type="file" name="upload" id="upload"
            hidden
            title="No file chosen"
            ref={uploadInputRef}
            onChange={onChangeHandler} 
            accept=".txt, .csv"
            onClick={(event) => {
              event.stopPropagation()
            }}
          >
          </input>
        </div>
      </div>
      <div className="mt-2" style={{minHeight: 74}}>
        {showCloseFlightCheckBox && 
          <FormControlLabel
            control={<Checkbox checked={closeFlight} onChange={handleChange} name="closeFlight" color="primary" />
            }
            label="Close flight (Relevant only for passengers)"
          />
        }
        {errMessage && <div className="alert alert-danger" dangerouslySetInnerHTML={{ __html: errMessage }} />}
      </div>

      <div className="row pb-2" >
        {props.showBackBtn &&
        <div className="col-auto">
          <AppButton id="backBtn" action={backhandler} label="Back" icon={<IoChevronBackCircle />}></AppButton>
        </div>
        }
        <div className="col"></div>
        <div className="col-auto">
          <AppButton id="submitBtn" action={uploadFileHandler} label="Submit" icon={<BsFillCursorFill />}  color="success" isLoading={spinnerLoading} style={{minWidth: 80}}></AppButton>
        </div>
      </div>
    </div>
  )
}

UploadFile.defaultProps = {
  showBackBtn: true,
  showFileList: true,
  uploadIconSize: '180px'
}

export default UploadFile;